import { render, staticRenderFns } from "./ContentTypeLabel.vue?vue&type=template&id=0780fd90&scoped=true&"
import script from "./ContentTypeLabel.vue?vue&type=script&lang=ts&"
export * from "./ContentTypeLabel.vue?vue&type=script&lang=ts&"
import style0 from "./ContentTypeLabel.vue?vue&type=style&index=0&id=0780fd90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0780fd90",
  null
  
)

export default component.exports